import React, { useState } from "react";
import "./Internships.css";
import { Helmet } from "react-helmet-async";

const Internships = () => {

    const [internshipOpenFAQ, setInternshipOpenFAQ] = useState(null);

    const internshipFAQs = [
        {
            question: "What internship opportunities does PRT Academy offer?",
            answer:
                "PRT Academy offers industry-oriented IT internship opportunities designed to help students and freshers develop practical technical skills through hands-on learning, projects, mentorship, and career-focused training."
        },
        {
            question: "Who can apply for an IT internship at PRT Academy?",
            answer:
                "Students, recent graduates, freshers, and aspiring IT professionals who want to gain practical software development experience can apply, subject to the eligibility requirements of the selected internship program."
        },
        {
            question: "Is PRT Academy's internship available in Hyderabad?",
            answer:
                "Yes. PRT Academy provides IT internship opportunities in Hyderabad. Students can contact the academy to learn about the current internship programs, availability, schedule, and application process."
        },
        {
            question: "What technologies can I learn during the internship?",
            answer:
                "The technologies covered depend on the selected internship program. Available areas may include Java, Python, Full Stack Development, MERN Stack, Data Structures & Algorithms. Students should check the specific program for its current curriculum."
        },
        {
            question: "Does the internship include practical projects?",
            answer:
                "Yes. The internship is designed to emphasize practical learning and project-based experience, helping participants apply their technical knowledge to development tasks and build stronger project portfolios."
        },
        {
            question: "Will I receive mentorship during the internship?",
            answer:
                "Yes. Participants receive guidance and mentorship throughout the internship to help them understand technical concepts, work through projects, improve problem-solving skills, and develop industry-relevant abilities."
        },
        {
            question: "Is the internship suitable for freshers?",
            answer:
                "Yes. PRT Academy internships can be suitable for freshers who want to strengthen their technical knowledge, gain practical project experience, and become better prepared for software development opportunities."
        },
        {
            question: "How can an internship help me build my IT career?",
            answer:
                "An IT internship can help you gain practical experience, develop technical and problem-solving skills, understand real development workflows, build projects for your portfolio, and improve your confidence for interviews and entry-level opportunities."
        },
        {
            question: "Will I receive an internship certificate?",
            answer:
                "Internship certificates may be provided to eligible participants who successfully complete the applicable internship requirements. Please contact PRT Academy for the current certificate eligibility and process."
        },
        {
            question: "Does PRT Academy provide placement assistance after the internship?",
            answer:
                "PRT Academy provides placement assistance as part of its career-support approach. Placement assistance may include interview preparation, resume guidance, mock interviews, career guidance, and job-search support, depending on the applicable program and eligibility."
        },
        {
            question: "How can I apply for an internship at PRT Academy?",
            answer:
                "You can contact PRT Academy through the internship enquiry or contact options on the website. The academy team can provide information about available programs, eligibility, schedules, and the next steps for applying."
        }
    ];

    const toggleInternshipFAQ = (index) => {
        setInternshipOpenFAQ(
            internshipOpenFAQ === index ? null : index
        );
    };

    return (
        <>
            <Helmet>
                <title>IT Internship in Hyderabad | PRT Academy</title>

                <meta
                    name="description"
                    content="Join PRT Academy for an IT Internship in Hyderabad with practical training, live projects, industry experience, mentorship, and career support for students & freshers."
                />

                <meta
                    name="keywords"
                    content="IT Internship in Hyderabad, Software Internship in Hyderabad, IT Internship for Freshers, Software Development Internship in Hyderabad, Full Stack Development Internship in Hyderabad, Java Internship in Hyderabad, Python Internship in Hyderabad, IT Internship for Students, Practical IT Internship"
                />
            </Helmet>

            <section className="internship-page">

                <div className="page-badge">
                    PRT Academy Internship
                </div>

                <h1>
                    Gain <span>Real Industry Experience</span>
                </h1>

                <p className="page-intro">
                    Work on practical projects, learn professional workflows
                    and develop skills that prepare you for software careers.
                </p>

                <div className="internship-grid">

                    <div className="internship-card">
                        <h2>Real Projects</h2>
                        <p>
                            Work on projects that simulate real software
                            development environments.
                        </p>
                    </div>

                    <div className="internship-card">
                        <h2>Mentor Guidance</h2>
                        <p>
                            Get guidance from experienced developers while
                            working through technical challenges.
                        </p>
                    </div>

                    <div className="internship-card">
                        <h2>Git & GitHub</h2>
                        <p>
                            Learn version control, branches, commits and
                            collaborative development.
                        </p>
                    </div>

                </div>


                {/* ================================
                    INTERNSHIP FAQ
                ================================= */}

                <section className="internship-faq-section">

                    <div className="internship-faq-badge">
                        Internship FAQ
                    </div>

                    <h2 className="internship-faq-title">
                        Frequently Asked <span>Questions</span>
                    </h2>

                    <p className="internship-faq-intro">
                        Find answers to common questions about PRT Academy
                        internships, eligibility, training and career support.
                    </p>

                    <div className="internship-faq-list">

                        {internshipFAQs.map((faq, index) => (

                            <div
                                className={`internship-faq-card ${
                                    internshipOpenFAQ === index
                                        ? "internship-faq-active"
                                        : ""
                                }`}
                                key={index}
                            >

                                <button
                                    type="button"
                                    className="internship-faq-question"
                                    onClick={() =>
                                        toggleInternshipFAQ(index)
                                    }
                                >

                                    <span>
                                        {faq.question}
                                    </span>

                                    <span className="internship-faq-icon">
                                        {internshipOpenFAQ === index
                                            ? "−"
                                            : "+"}
                                    </span>

                                </button>

                                {internshipOpenFAQ === index && (

                                    <div className="internship-faq-answer">

                                        <p>
                                            {faq.answer}
                                        </p>

                                    </div>

                                )}

                            </div>

                        ))}

                    </div>

                </section>

            </section>
        </>
    );
};

export default Internships;